import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAhMroZKqnfWUEgR4PTJJeniXBDN15GRHw",
    authDomain: "nextup-wealth-management.firebaseapp.com",
    projectId: "nextup-wealth-management",
    storageBucket: "nextup-wealth-management.firebasestorage.app",
    messagingSenderId: "76308630155",
    appId: "1:76308630155:web:00e9ccc547797f24a2e28e",
    measurementId: "G-EQ08R91RCB"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
